var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmilleIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "smiley_18px",
    transform: "translate(-480 -5350)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_465",
    "data-name": "Rectangle 465",
    width: 18,
    height: 18,
    transform: "translate(480 5350)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "smile_1_",
    "data-name": "smile (1)",
    transform: "translate(479 5349)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(2 2)",
    fill: "rgba(0,0,0,0)",
    stroke: "#a0a0a0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M8,14a5.4,5.4,0,0,0,4,2,5.4,5.4,0,0,0,4-2",
    transform: "translate(-2 -2.667)",
    fill: "rgba(0,0,0,0)",
    stroke: "#a0a0a0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_100",
    "data-name": "Line 100",
    x2: 0.01,
    transform: "translate(7.599 7.6)",
    fill: "none",
    stroke: "#a0a0a0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_101",
    "data-name": "Line 101",
    x2: 0.01,
    transform: "translate(12.399 7.6)",
    fill: "none",
    stroke: "#a0a0a0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmilleIcon);
export default __webpack_public_path__ + "static/media/smille_icon.30008eabca00a6c9ee5c712502815de2.svg";
export { ForwardRef as ReactComponent };